import { Video } from "./video";

export interface TrainingSession {
    id: number;
    name: string;
    description: string;
    goals: string;
    date_time: string;
    phases: TrainingSessionPhase[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTrainingSession: TrainingSession = {
    id: 0,
    name: '',
    description: '',
    goals: '',
    date_time: '',
    phases: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface TrainingSessionRecipient {
    type: string;
    reference: string;
    label: string;
}

export interface TrainingSessionPhase {
    id: number;
    name: string;
    description: string;
    goals: string;
    videos: Video[],
    weight: number;
    recipients: TrainingSessionRecipient[];
    exercises: TrainingSessionExercise[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTrainingSessionPhase: TrainingSessionPhase = {
    id: 0,
    name: '',
    description: '',
    goals: '',
    videos: [],
    weight: 0,
    recipients: [],
    exercises: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface TrainingSessionExercise {
    id: number;
    name: string;
    description: string;
    goals: string;
    videos: Video[],
    weight: number;
    recipients: TrainingSessionRecipient[],
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyTrainingSessionExercise: TrainingSessionExercise = {
    id: 0,
    name: '',
    description: '',
    goals: '',
    videos: [],
    weight: 0,
    recipients: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}